module.exports = __webpack_public_path__ + "static/media/homepage_service.985a4df7.svg";